// extracted by mini-css-extract-plugin
export default {"cls1":"epG9OcWZXflpXrUrZrjE","cls2":"mEeETk66EkB9M6buIVJL epG9OcWZXflpXrUrZrjE","isPhone":"IaZMLz7Oxv8_e1wf42Ij"};